export default __webpack_public_path__ + "static/022-d4561a0fe623d9dbe7f4738a8307fed0.jpg";